// Cross-domain URL builder for auth pages.
// Landing site lives at sendvertex.com; app lives at app.sendvertex.com.
// If REACT_APP_APP_URL is set (e.g., https://app.sendvertex.com), we produce a
// full URL so that Login/Register on the marketing site cross-jumps to the app.
// In dev/preview where REACT_APP_APP_URL is empty, we return a same-origin path.

const APP_URL = (process.env.REACT_APP_APP_URL || "").replace(/\/$/, "");

export function appUrl(path = "/") {
  if (!APP_URL) return path;
  return `${APP_URL}${path.startsWith("/") ? path : "/" + path}`;
}

// True when we're currently pointing at a different origin than the running page.
export function isCrossOrigin(path = "/") {
  if (!APP_URL) return false;
  try {
    const target = new URL(appUrl(path));
    return target.origin !== window.location.origin;
  } catch {
    return false;
  }
}
